import { Component } from '@angular/core';
import { TableComponent } from '../../../../shared/component/table/table.component';
import { CommonModule } from '@angular/common';
import { ApiCallsService } from '../../../../shared/services/api-calls.service';
import { AgGridTableService } from '../../../../shared/services/ag-grid.service';
import { GroupActionSelectorComponent, TypeOption } from '../../../../shared/component/group-action-selector/group-action-selector.component';
import { ClickOutsideDirective } from "../../../../shared/directives/outside.directive";
import { ToastService } from '../../../../shared/services/toast.service';
import { RestoreResultComponent } from "../../../../shared/component/groupactionresult/groupaction";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-gr-restore',
  imports: [GroupActionSelectorComponent, TableComponent, CommonModule, RestoreResultComponent],
  templateUrl: './gr-restore.component.html',
  styleUrl: './gr-restore.component.scss'
})
export class GrRestoreComponent {
  constructor(private apiservice :ApiCallsService,private aggrid:AgGridTableService,private toast:ToastService){}
  filterPayload: any = {};
  bulkResult:any
  showResult:boolean = false
  dropdownOption:TypeOption[] =
  [
    { label: 'Balance', value: 'balance' },
    { label: 'Overload', value: 'overload' }]

handlereset() {
  
  this.filterPayload = {}
  this.aggrid.processTableData([])
  this.showtable = false,
  this.showResult = false
  this.bulkResult = []
}
handleFilters(event: any) {
  try {
    if (!event) {
      console.error('Filter event is missing');
      this.showtable = false;
      return;
    }

    const normalize = (value: any): string | undefined => {
      if (!value || (Array.isArray(value) && value.length === 0)) return undefined;

      return Array.isArray(value) ? value.join(',') : value;
    };

    this.filterPayload = {
      site_id: normalize(event.siteIds) || event.siteId,
      tower_id: normalize(event.towerIds),
      type: event.type
    };

    // Validate required fields (adjust based on your API requirement)
    if (!this.filterPayload.site_id) {
      console.warn('Site ID is required');
      return;
    }

    this.showtable = true;

    setTimeout(() => {
      this.apiservice.getMaintanenceLocationList(this.filterPayload)
        .subscribe({
          next: (data: any) => {
            if (!data) {
              console.error('Empty API response');
              this.showtable = false;
              return;
            }

            // Optional: check structure
            if (!data.Data) {
              console.warn('Unexpected response structure', data);
                this.showtable = false,
                this.showResult = false
                this.bulkResult = []
                return
            }
            if (data.Message === 'No Data Found') {
              this.DISABLEBTN = true
            }
            else{
              this.DISABLEBTN = false
            }
            this.aggrid.processTableData(data, '', false, true);
          },

          error: (err: any) => {
            console.error('API Error:', err);
            this.showtable = false;

            // Optional: show toast
            // this.notificationService.error('Failed to load data');
          },

          complete: () => {
            console.log('API call completed');
          }
        });
    }, 10);

  } catch (error) {
    console.error('Unexpected error in handleFilters:', error);
    this.showtable = false;
  }
}
DISABLEBTN:boolean = false
getcheckboxitems() {
  const selected = this.aggrid.checkboxHandler(['id', 'name']);

  if (!selected || selected.length === 0) {
    this.toast.showToast('Please select at least one record', 'colored', 3000, 'warning');
    return;
  }
  this.showResult = false

  const mappedItems = selected.map((i: any) => ({
    id: i.id,
    name: i.name,
    status: 'pending',
    failure: ''
  }));

  this.bulkResult = mappedItems

  const locationIds = mappedItems.map(i => i.id).join(',');

  const formData = new FormData();

  formData.append('site_id', this.filterPayload.site_id || '8103e340-3d93-11e4');
  formData.append('Action', 'POWERRESTORE');

  if (this.filterPayload.tower_id) {
    formData.append('TowerId', this.filterPayload.tower_id);
  }

  formData.append('type', this.filterPayload.type || 'overload');
  formData.append('location_id', locationIds);

  Swal.fire({
    title: 'Are you sure?',
    text: `Do you want to Restore Selected Units Meters?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33'
  }).then((result) => {

    if (!result.isConfirmed) {
      this.toast.showToast(`Action canceled`, 'colored', 3000, 'danger');
      return;
    }
    this.apiservice
      .BulkCommandSubmit(formData, 'BulkRestoreTowerWise')
      .subscribe((res: any) => {
        this.handleBulkResponse(res);
      });


  });
}
handleBulkResponse(res: any) {
  if (!res || res.StatusCode !== 200) {
    this.toast.showToast('Something went wrong', 'colored', 4000, 'danger');
    return;
  }

  const successIds: string[] = res?.Data?.success || [];
  const failedObj: Record<string, string> = res?.Data?.failed || {};

  // ✅ Map results back
  this.bulkResult = this.bulkResult.map((item:any) => {
    if (successIds.includes(item.id)) {
      return {
        ...item,
        status: 'success',
        failure: ''
      };
    }

    if (failedObj[item.id]) {
      return {
        ...item,
        status: 'failed',
        failure: failedObj[item.id]
      };
    }

    return item;
  });
  this.showResult=true
}
showtable:boolean = false
}
